import React, { useEffect } from "react";
import { getFirebaseToken, onForegroundMessage } from "../firebase";
import { sendPushToken } from "../services/notifications";
import { useUserContext } from "./user";

const NotificationHandler: React.FC = () => {
    const { jwtToken, notificationsEnabled } = useUserContext();

    // токен web push ротируется перерегистрируем если сменился иначе пуши уходят на старый
    useEffect(() => {
        if (!jwtToken || notificationsEnabled !== true) return;
        getFirebaseToken().then(token => {
            if (token && token !== localStorage.getItem("xFcmToken")) {
                sendPushToken(token, jwtToken).catch(() => {});
            }
        });
    }, [jwtToken, notificationsEnabled]);

    useEffect(() => {
        // Запрос разрешений и токена
        getFirebaseToken().then().catch();

        console.log("[fcm] foreground listener подключён");

        // Постоянная подписка foreground срабатывает на каждое сообщение пока вкладка активна
        const unsubscribe = onForegroundMessage((payload: any) => {
            console.log("[fcm foreground] получен пуш", payload);
            // вкладка не активна фон покажет service worker тут не дублируем
            if (document.visibilityState !== "visible") {
                console.log("[fcm foreground] вкладка не активна показ оставляем service worker");
                return;
            }

            const title = payload.notification?.title || payload.data?.title || "Melon Business Travel";
            const body = payload.notification?.body || payload.data?.body || "Новое уведомление";

            // firebase sw на кастомном scope страница им не управляется serviceWorker.ready висит берём регистрацию явно
            navigator.serviceWorker.getRegistrations().then((regs) => {
                const registration =
                    regs.find((r) => r.scope.includes("firebase-cloud-messaging-push-scope")) || regs[0];
                if (!registration) {
                    console.log("[fcm foreground] нет sw регистрации для показа");
                    return;
                }
                registration.showNotification(title, {
                    body,
                    icon: "/logo192.png",
                    data: { claim_pk: payload.data?.claim_pk ?? null },
                });
                console.log("[fcm foreground] показано уведомление", title);
            });
        });

        return () => {
            unsubscribe();
        };
    }, []);

    return null;
};

export default NotificationHandler;